import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { api, formatApiError } from "../lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function OcrRulesPage() {
  const [rules, setRules] = useState([]);
  const [types, setTypes] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ document_type_code: "", keywords: "", priority: 100 });
  const [err, setErr] = useState("");

  const load = async () => {
    const [r, t] = await Promise.all([api.get("/ocr-rules"), api.get("/document-types")]);
    setRules(r.data);
    setTypes(t.data);
    if (!form.document_type_code && t.data[0]) setForm((f) => ({ ...f, document_type_code: t.data[0].code }));
  };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await api.post("/ocr-rules", {
        document_type_code: form.document_type_code,
        keywords: form.keywords.split(",").map((s) => s.trim()).filter(Boolean),
        priority: parseInt(form.priority) || 100,
      });
      setOpen(false);
      setForm({ document_type_code: types[0]?.code || "", keywords: "", priority: 100 });
      load();
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail));
    }
  };
  const remove = async (id) => {
    if (!window.confirm("Delete rule?")) return;
    await api.delete(`/ocr-rules/${id}`);
    load();
  };

  return (
    <AppShell
      title="OCR Classification Rules"
      actions={
        <button data-testid="new-rule-button" className="ds-btn-primary flex items-center gap-2" onClick={() => setOpen(true)}>
          <Plus size={14} /> New rule
        </button>
      }
    >
      <div className="ds-card overflow-x-auto">
        <table className="ds-table" data-testid="rules-table">
          <thead>
            <tr><th>Priority</th><th>Document Type</th><th>Keywords</th><th /></tr>
          </thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.id}>
                <td className="font-mono text-[12px]">{r.priority}</td>
                <td className="font-semibold">{r.document_type_code}</td>
                <td className="text-[12px]">
                  {r.keywords.map((k) => (
                    <span key={k} className="ds-badge mr-1 mb-1" style={{ borderColor: "#E5E5E9", background: "#F7F7F8" }}>{k}</span>
                  ))}
                </td>
                <td className="text-right">
                  <button className="ds-btn-ghost" onClick={() => remove(r.id)} data-testid={`delete-rule-${r.id}`}>
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={() => setOpen(false)}>
          <form onClick={(e) => e.stopPropagation()} onSubmit={submit} className="ds-card p-6 w-full max-w-md" data-testid="new-rule-form">
            <h3 className="font-display text-lg font-bold mb-4">Create rule</h3>
            <div className="space-y-3">
              <div>
                <label className="ds-label">Document type</label>
                <select className="ds-input" value={form.document_type_code} onChange={(e) => setForm({ ...form, document_type_code: e.target.value })} data-testid="new-rule-type">
                  {types.map((t) => <option key={t.code} value={t.code}>{t.name} ({t.code})</option>)}
                </select>
              </div>
              <div>
                <label className="ds-label">Keywords (comma separated)</label>
                <input className="ds-input" required value={form.keywords} onChange={(e) => setForm({ ...form, keywords: e.target.value })} data-testid="new-rule-keywords" />
              </div>
              <div>
                <label className="ds-label">Priority (lower = higher)</label>
                <input className="ds-input" type="number" value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })} data-testid="new-rule-priority" />
              </div>
              {err && <div className="text-[12px] text-[#B42318]">{err}</div>}
            </div>
            <div className="mt-5 flex justify-end gap-2">
              <button type="button" className="ds-btn-secondary" onClick={() => setOpen(false)}>Cancel</button>
              <button type="submit" className="ds-btn-primary" data-testid="new-rule-submit">Create</button>
            </div>
          </form>
        </div>
      )}
    </AppShell>
  );
}
